<template>
	<div class="container col-lg-6 px-4 py-5 mt-5">
		<div class="row justify-content-center pt-5 mt-5">
			<div class="col-12 col-md-8 col-lg-6">
				<div class="text-center mb-5">
					<img src="@/assets/equivate_logo.svg" alt="Equivate logo">
				</div>

				<h4 class="mb-4">Select Organization</h4>

				<div v-if="error" class="alert alert-danger" role="alert">
					{{ error }}
				</div>

				<div v-if="loading" class="text-center">
					<div class="spinner-border text-primary" role="status">
						<span class="visually-hidden">Loading...</span>
					</div>
				</div>

				<div v-else class="list-group">
					<button
						v-for="tenant in tenants"
						:key="tenant.id"
						type="button"
						class="list-group-item list-group-item-action d-flex justify-content-between align-items-center"
						:class="{ active: selectedId === tenant.id }"
						@click="selectTenant(tenant)"
					>
						{{ tenant.name }}
						<span v-if="selectedId === tenant.id" class="spinner-border spinner-border-sm" role="status"></span>
					</button>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import { authState, authService, authMutations, sessionMonitor } from '@/auth'

export default {
	name: 'TenantSelectorView',

	data() {
		return {
			selectedId: null,
			loading: false,
			error: null
		}
	},

	computed: {
		tenants() {
			return authState.availableTenants
		}
	},

	mounted() {
		// If only one tenant, auto-select it
		if (this.tenants.length === 1) {
			this.selectTenant(this.tenants[0])
		}
	},

	methods: {
		async selectTenant(tenant) {
			this.selectedId = tenant.id
			this.error = null

			try {
				const result = await authService.selectTenant(tenant.id)
				authMutations.setActiveTenant(result.activeTenant || tenant)
				authMutations.setPermissions(result.permissions)
				sessionMonitor.start()

				localStorage.setItem('lastSelectedTenantId', tenant.id)
				this.$router.push(this.$route.query.redirect || '/')
			} catch (e) {
				this.error = 'Failed to select organization. Please try again.'
				this.selectedId = null
			}
		}
	}
}
</script>

<style scoped>
img {
	width: 152px;
	height: 37px;
}
</style>
